import type { ReactNode } from 'react';
import { IdentifyPartyRouteCard } from './IdentifyPartyRouteCard';
import {
  removePartyRouteAt,
  replacePartyRouteAt,
  type IdentifyPartyEntityName,
  type IdentifyPartyPicker,
} from './identifyPartyFormConfig';
import {
  isDuplicateEntityId,
  partyRouteRowKey,
  type PartyRoute,
} from './parsePartyRoutes';

export function IdentifyPartyRouteList({
  routes,
  siblingSets,
  entityCounts,
  reserved,
  slugFallback,
  duplicateMessage,
  noEntitySelectedLabel,
  emptyRoutesHelp,
  renderPicker,
  EntityName,
  onRoutesChange,
}: {
  routes: PartyRoute[];
  siblingSets: Array<Set<string>>;
  entityCounts: Map<string, number>;
  reserved: Set<string>;
  slugFallback: string;
  duplicateMessage: ReactNode;
  noEntitySelectedLabel: ReactNode;
  emptyRoutesHelp: ReactNode;
  renderPicker: IdentifyPartyPicker;
  EntityName: IdentifyPartyEntityName;
  onRoutesChange: (next: PartyRoute[]) => void;
}) {
  if (routes.length === 0) {
    return (
      <p className="text-xs text-muted-foreground italic px-1">
        {emptyRoutesHelp}
      </p>
    );
  }

  return (
    <div className="space-y-2">
      {routes.map((route, index) => (
        <IdentifyPartyRouteCard
          key={partyRouteRowKey(route, index)}
          route={route}
          index={index}
          total={routes.length}
          siblingIds={siblingSets[index] ?? new Set<string>()}
          reserved={reserved}
          slugFallback={slugFallback}
          duplicate={isDuplicateEntityId(route.entityId, entityCounts)}
          duplicateMessage={duplicateMessage}
          noEntitySelectedLabel={noEntitySelectedLabel}
          renderPicker={renderPicker}
          EntityName={EntityName}
          onChange={(updated) =>
            onRoutesChange(replacePartyRouteAt({ routes, index, updated }))
          }
          onRemove={() => onRoutesChange(removePartyRouteAt(routes, index))}
        />
      ))}
    </div>
  );
}
